import axios from "axios";
import { base_url } from "../config";

export const submitAnswers = async (answers) => {
  const accessToken = localStorage.getItem("@user");
  const url = `${base_url}/no-host-questions/save`;

  try {
    const response = await axios.post(url, answers, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error submitting answers:", error);
    throw new Error(
      error.response
        ? `Failed to submit answers: ${error.response.data}`
        : error.message
    );
  }
};
